import { useCallback, useMemo, useRef, useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  // Grid,
  Container,
  CircularProgress,
  useTheme,
  Grid,
  // Paper,
  Link,
} from "@mui/material";
import moment from "moment";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
// import RoomIcon from "@mui/icons-material/Room";
import { useLocation, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setStoreData as setStore } from "../redux/action";
import { getAPI } from "../api/callAPI";

import { isObject } from "lodash";
import NotFound from "../Common/NotFound";
import UpcomingEvents from "../Common/UpcomingEvents";
// import Facilities from "../Common/Facilities";
// import ImageGallery from "../Common/ImageGallery";
// import MenuButton from "../Common/MenuButton";
// import OpeningHours from "../Common/OpeningHours";
// import { TbMapShare } from "react-icons/tb";
// import { MdMyLocation } from "react-icons/md";
import { LuMapPin } from "react-icons/lu";
// import { RiUserAddLine } from "react-icons/ri";
// import { FaInstagram } from "react-icons/fa";
// import { FiFacebook } from "react-icons/fi";
// import { CiYoutube } from "react-icons/ci";
// import { RiTwitterXLine } from "react-icons/ri";
// import { IoShareSocialOutline, IoCopyOutline } from "react-icons/io5";
// import Footer from "../Common/Footer";
import { SlCalender } from "react-icons/sl";
import { FaRegClock, FaHourglass } from "react-icons/fa6";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { getConfigText } from "../Common/utils";

const EventDetails = () => {
  const { palette } = useTheme();
  const eventsRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { storeSlug, eventID } = useParams();
  const { endpoint, appConfigs } = useSelector((state) => state.auth);
  const [expanded, setExpanded] = useState(false);
  const [storeLoading, setStoreLoading] = useState(true);
  const [storeData, setStoreData] = useState(null);
  const [eventData, setEventData] = useState(null);
  const [error, setError] = useState("");
  const queryParams = new URLSearchParams(location.search);
  const eventName = queryParams.get("event"); // 'Live Event'

  const storeID = useMemo(() => {
    return storeData?.id;
  }, [storeData]);

  const eventDesc = useMemo(() => {
    // || eventData?.term
    if (eventData?.description) {
      // return `${eventData.description}\n\n\nTerms:\n${eventData?.term}`;
      return eventData.description;
    }
    return null;
  }, [eventData]);

  const webImage = useMemo(() => {

    const wImg = getConfigText(appConfigs, 'web_image');
    return wImg && wImg !== '' ? wImg : storeData?.image || '';
  }, [appConfigs, storeData]);

  // const storeID = useMemo(() => {
  //   if (location?.state?.storeID) {
  //     // return location.pathname.replace("/event/", "");
  //     return location?.state?.storeID;
  //   }
  //   return null;
  // }, [location.state]);

  // const liveEvent = useMemo(() => {
  //   if (location?.state?.liveEvent) {
  //     return location?.state?.liveEvent;
  //   }
  //   return null;
  // }, [location.state]);

  const openEventDetails = (item) => {
    // console.log(item, "itemsjhjhjhjh");
    dispatch(setStore(item));
    // navigate(`/event/${item?.id}?event=${item?.name}`);
    navigate(`/web/${storeSlug}/event/${item.slug}`);
    // navigate(`/event/${item?.id}?event=${item?.name}`, {
    //   state: {
    //     storeID: storeID,
    //     liveEvent: item,
    //   },
    // });
  };

  const checkStore = useCallback(async () => {
    if (storeSlug) {
      dispatch(setStore({}));
      setStoreLoading(true);
      try {
        const resp = await getAPI(endpoint, `stores/${storeSlug}`);

        dispatch(setStore(resp?.data["0"]));
        setStoreData(resp?.data["0"]);
      } catch (error) {
        console.error("checkStore error >>> ", error);
        dispatch(setStore({}));
        setStoreData(null);
        setError("Store Not Found");
      }
      setStoreLoading(false);
    } else {
      setStoreData(null);
      dispatch(setStore({}));
      setError("Store Not Found");
      setStoreLoading(false);
    }
  }, [storeSlug, dispatch, endpoint]);

  useEffect(() => {
    checkStore();
  }, [checkStore, endpoint]);

  // Set dynamic page title
  useDocumentTitle(eventData?.name || "Event Details");

  // const scrollToEvents = () => {
  //   eventsRef.current?.scrollIntoView({ behavior: "smooth" });
  // };

  if (storeLoading) {
    return (
      <Container maxWidth="lg">
        <CircularProgress variant="indeterminate" />
      </Container>
    );
  }

  if (error || !isObject(storeData) || Object.keys(storeData).length === 0) {
    return <NotFound />;
  }

  const toggleExpanded = () => {
    setExpanded((prev) => !prev);
  };

  const getWords = (text, wordLimit = 50) => {
    const words = text?.split(" ") || [];
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ") + "...";
  };

  const shouldTruncate = eventDesc?.split(" ")?.length > 50;

  function formatDate(isoDateStr) {
    if (!isoDateStr) return "";

    // const date = new Date(isoDateStr);

    // Format: 26 May, 2025
    // return date.toLocaleDateString("en-GB", {
    //   day: "numeric",
    //   month: "short",
    //   year: "numeric",
    // });

    return moment(isoDateStr).format("DD MMM[,] YYYY");
  }

  function formatTime(timeStr) {
    if (!timeStr) return "";

    // // parse timeStr "21:00:00"
    // const [hour] = timeStr.split(":").map(Number);
    // // minute
    // // Convert 24h to 12h format
    // const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    // const ampm = hour >= 12 ? "PM" : "AM";

    // return `${hour12} ${ampm} Onwards`;

    return `${moment(timeStr, "HH:mm:ss").format("h:mm a")} Onwards`;
  }

  // const handleCopy = () => {
  //   const url = window.location.href;

  //   if (navigator?.clipboard?.writeText) {
  //     navigator.clipboard
  //       .writeText(url)
  //       .then(() => {
  //         alert("Link copied to clipboard!");
  //       })
  //       .catch((err) => {
  //         console.error("Clipboard write failed:", err);
  //         fallbackCopy(url);
  //       });
  //   } else {
  //     fallbackCopy(url);
  //   }
  // };

  // Fallback method using a hidden input
  // const fallbackCopy = (text) => {
  //   const textarea = document.createElement("textarea");
  //   textarea.value = text;
  //   textarea.style.position = "fixed"; // Prevent scrolling to bottom
  //   document.body.appendChild(textarea);
  //   textarea.focus();
  //   textarea.select();
  //   try {
  //     document.execCommand("copy");
  //     alert("Link copied!");
  //   } catch (err) {
  //     alert("Copy failed. Please copy manually.");
  //   }
  //   document.body.removeChild(textarea);
  // };

  // console.log(eventData, "eventData");
  return (
    <>
      <Container className="pt-4 ">
        {/* Hero Section */}
        <Grid container spacing={2} className="justify-content-center">
          <Grid item xs={12} md={10} lg={8}>
            <Typography className="title-backbtn mb-4">
              {location.key !== "default" && (
                <Button
                  variant="outlined"
                  startIcon={
                    <ArrowBackRoundedIcon color="primary" fontSize="large" />
                  }
                  size="large"
                  onClick={() => navigate(-1)}
                  sx={{
                    backgroundColor: palette.common.white,
                  }}
                ></Button>
              )}
              {/* <Typography 
                  variant="body1" 
                  sx={{ mb: 1, fontWeight: "500" }}
                > */}
                  <Link
                    href={`/web/${storeSlug}`}
                    sx={{ 
                      textDecoration: "none", 
                      color: "primary.main",
                      "&:hover": { textDecoration: "underline" }
                    }}
                  >
                    {eventData?.store?.name || storeData?.name}
                  </Link>
                {/* </Typography> */}
                {" "}&gt;{" "}
              <span className="event-name-breadcrum">{eventData?.name || ''}</span>
            </Typography>

            <img
              src={eventData?.event_image || webImage}
              alt="event_image"
              className="w-100 detail-img"
            />
            <Box className="d-flex justify-content-between mt-4 location-main-outer event-location-main align-items-center">
              <Box>
                <Typography
                  variant="h5"
                  gutterBottom
                  color={"primary"}
                  sx={{ fontWeight: "600" }}
                >
                  {eventName}
                </Typography>
                
                <Typography className="address-outer event-title-outer">
                  <LuMapPin />{" "}
                  {`${
                    eventData?.store?.address_line_1 ||
                    storeData?.address_line_1
                  }, ${
                    eventData?.store?.address_line_2 || storeData.address_line_2
                  }, ${eventData?.store?.city || storeData.city}`}
                </Typography>
              </Box>
              <Box className="btn-event-outer">
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  onClick={() => {
                    // navigate(`/store/${storeID}`);
                    // navigate(`/web/${storeSlug}/book-a-table`);
                    navigate(`/web/${storeSlug}/book-a-table`, {
                      state: {
                        liveEvent: eventData,
                      },
                    });
                  }}
                  className="darkbtn eventbtn"
                >
                  Book an Event
                </Button>
              </Box>
            </Box>
            <Box className="date-event-wrapper mt-3 d-flex mb-3">
              <Typography>
                <SlCalender />
                {formatDate(eventData?.event_date)}
              </Typography>

              <Typography className="time-wrapper">
                <FaRegClock /> {formatTime(eventData?.time)}
              </Typography>

              <Typography>
                <FaHourglass /> {eventData?.hours} Hours
              </Typography>
            </Box>
            {eventDesc && (
              <Box p={3} className="about-data mt-4">
                <Typography
                  variant="h5"
                  gutterBottom
                  color={"primary"}
                  sx={{ fontWeight: "600" }}
                >
                  {/* About {eventData?.store?.name || storeData.name} */}
                  About {eventData?.name}
                </Typography>

                <Typography
                  variant="body1"
                  mb={0}
                  mt={2}
                  sx={{
                    textAlign: "justify",
                    maxWidth: 800,
                  }}
                  className="about-content"
                >
                  {expanded || !shouldTruncate
                    ? eventDesc
                    : getWords(eventDesc)}
                  {shouldTruncate && (
                    <Link
                      component="button"
                      onClick={toggleExpanded}
                      sx={{ mt: 1, display: "block" }}
                      className="readmore-btn"
                    >
                      {expanded ? "Read less" : "Read more"}
                    </Link>
                  )}
                </Typography>

                {eventData?.term && (
                  <>
                    <Typography
                      variant="h5"
                      // gutterBottom
                      color={"primary"}
                      sx={{ fontWeight: "600", mt: 2 }}
                    >
                      {/* About {eventData?.store?.name || storeData.name} */}
                      General Terms
                    </Typography>
                    <Typography
                      variant="body1"
                      mb={0}
                      mt={2}
                      sx={{
                        textAlign: "justify",
                        maxWidth: 800,
                      }}
                      className="about-content"
                    >
                      {eventData?.term || ""}
                    </Typography>
                  </>
                )}
              </Box>
            )}

            {/* <Box className="share-section mt-5">
              <Typography
                variant="h5"
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: "600" }}
                className="facilities-outer mt-4 mb-3"
              >
                Share with friends
              </Typography>
              <Box className="share-media">
                <Link href="#" target="_blank" rel="noopener">
                  <FiFacebook />
                  Share on Facebook
                </Link>
                <Link href="#" target="_blank" rel="noopener">
                  <RiTwitterXLine />
                  Share on X (Formerly Twitter)
                </Link>
                <Typography
                  onClick={handleCopy}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <IoCopyOutline />
                  Copy Link
                </Typography>
              </Box>
            </Box> */}

            <Box className="all-events-wrapper" ref={eventsRef}>
              {/* <Typography variant="h5" className="subtitle-main mt-5">
                Events you may also like
              </Typography> */}

              <UpcomingEvents
                storeID={storeID}
                eventID={eventID}
                openEventDetails={openEventDetails}
                setEventData={setEventData}
                title={"Events you may also like"}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default EventDetails;
